var layout_default = {
  "layoutWrapper": "TN2Vb",
  "layout": "kXbYr",
  "mobile": "BwAaR",
  "cell": "kyY-t"
};
export {
  layout_default as default
};
//# sourceMappingURL=layout-scss.js.map
